import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, errMsg } from "../../lib/api";

const lastMonth = () => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const MonthlyReport = () => {
  const [month, setMonth] = useState(lastMonth());
  const [busy, setBusy] = useState(false);
  const { data } = useQuery({ queryKey: ["monthly", month], queryFn: () => api.get("/admin/reports/monthly", { params: { month } }).then((r) => r.data), enabled: !!month });
  const send = async () => {
    setBusy(true);
    try {
      await api.post("/admin/reports/monthly", null, { params: { month } });
      toast.success("Report emailed to you");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const stats = [["Requests raised", data?.raised], ["Booking lists", data?.bookings], ["Enquiry forms", data?.enquiries], ["Orders confirmed", data?.orders]];
  return (
    <div className="mb-8 rounded-[24px] border border-[#D4AF37]/20 bg-[#330B2E]/70 p-5" data-testid="monthly-report-panel">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="font-display text-3xl">Monthly report</h2>
          <p className="text-sm text-[#E8D8C8]">Emailed to you automatically on the 1st of every month (9am) for the previous month.</p>
        </div>
        <div className="flex items-center gap-2">
          <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-11 w-44 rounded-xl border-[#D4AF37]/25 bg-[#190317]/60 [color-scheme:dark]" data-testid="monthly-report-month" />
          <button onClick={send} disabled={busy || !month} className="inline-flex h-11 items-center gap-2 rounded-full bg-gold-foil px-5 text-sm font-semibold text-[#240620] disabled:opacity-60" data-testid="monthly-report-send">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Mail size={15} />} Email me this report
          </button>
        </div>
      </div>
      <div className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-4">
        {stats.map(([k, v]) => (
          <div key={k} className="rounded-2xl bg-[#190317]/60 p-4" data-testid={`monthly-stat-${k.toLowerCase().replace(/ /g, "-")}`}>
            <p className="font-display text-4xl text-[#F3E5AB]">{v ?? "-"}</p>
            <p className="text-xs text-[#E8D8C8]">{k}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
